import { throwError, type Observable } from 'rxjs';
import type { CrudOps } from '../../../stores/generic.store';
import type { Permission } from '../../../types/permission.interface';
import type { PermissionsService } from '../generated/permissions/permissions.service';

// Permissions are read-only on the backend; the swagger only declares GET /permissions.
// Mutation handlers stay typed but reject at call time to surface accidental usage.
const unsupported = <T>(op: string): Observable<T> => throwError(() => new Error(`PermissionsService does not expose ${op}`));

export const permissionCrud: CrudOps<Permission, PermissionsService> = {
  getAll: svc => svc.getPermissionListResource<Permission[]>(),
  getById: () => unsupported('getById'),
  create: () => unsupported('create'),
  update: () => unsupported('update'),
  delete: () => unsupported('delete'),
};
